module.exports = __webpack_public_path__ + "img/kayak.0943a392.svg";